// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright (c) Microsoft Corporation. */
/* Licensed under the MIT License. */

body,
html,
.Root {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
    'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

html,
body {
  /* Prevent pull down to refresh behavior on mobile */
  overscroll-behavior-y: contain;
}
`, "",{"version":3,"sources":["webpack://./src/cti/index.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC,oCAAoC;;AAEpC;;;EAGE;8CAC4C;EAC5C,mCAAmC;EACnC,kCAAkC;EAClC,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,oDAAoD;EACpD,8BAA8B;AAChC","sourcesContent":["/* Copyright (c) Microsoft Corporation. */\n/* Licensed under the MIT License. */\n\nbody,\nhtml,\n.Root {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',\n    'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n\nhtml,\nbody {\n  /* Prevent pull down to refresh behavior on mobile */\n  overscroll-behavior-y: contain;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
